import { SET_CURRENT_RESTAURANT_DETAILS } from '../actions';

export default function currentRestaurantDetails(state = null, action) {
    switch (action.type) {
      case SET_CURRENT_RESTAURANT_DETAILS:
        return action.payload;
      default:
        return state;
    }
  }



// WEBPACK FOOTER //
// ./src/store/reducers/currentRestaurantDetails.js